import React from "react";
import styles from "./Search.module.css";
import { SearchIcon } from "lucide-react";

export const Search = ({
  handleSearchChange,
  query,
  dataCy,
}: {
  handleSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  query: string;
  dataCy?: string;
}) => {
  return (
    <div className={styles.inputSearchContainer}>
      <SearchIcon className={styles.searchIcon} />
      <input
        type="text"
        placeholder="Search by name, topic, or keyword"
        value={query}
        onChange={handleSearchChange}
        className={styles.searchInput}
        data-cy={dataCy}
      />
    </div>
  );
};
